/*
 * The sign-up's details for this visit: { name, organisation, email, phone }
 * in sessionStorage['ng.signup'], written after step 1 and again once the code
 * is verified. /next-step reads them so "Book a live demo" confirms instead of
 * re-asking. One visit only, never in the URL; storage can be unavailable
 * (private mode, blocked site data), so every access fails quietly.
 */
const STORAGE_KEY = 'ng.signup';
const FIELDS = ['name', 'organisation', 'email', 'phone'];

export function readCapturedDetails() {
  try {
    const parsed = JSON.parse(window.sessionStorage.getItem(STORAGE_KEY));
    if (!parsed || typeof parsed !== 'object') return null;
    const details = {};
    FIELDS.forEach((f) => {
      details[f] = typeof parsed[f] === 'string' ? parsed[f] : '';
    });
    // The sign-up requires these three; without them there is nothing to confirm.
    return details.organisation && details.email && details.phone ? details : null;
  } catch {
    return null;
  }
}

export function clearCapturedDetails() {
  try {
    window.sessionStorage.removeItem(STORAGE_KEY);
  } catch {
    // Storage unavailable: nothing stored to clear.
  }
}

export function writeCapturedDetails(details) {
  try {
    const clean = {};
    FIELDS.forEach((f) => {
      clean[f] = String(details[f] || '').trim();
    });
    window.sessionStorage.setItem(STORAGE_KEY, JSON.stringify(clean));
  } catch {
    // Storage unavailable: /next-step falls back to its short form.
  }
}
